"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  AddressArea: 'Area',
  AddressArea_Placeholder: 'Your area',
  AddressArea_Tooltip: 'Enter your area',
  AddressCity: 'City',
  AddressCity_Placeholder: 'Your city',
  AddressCity_Tooltip: 'Enter your city',
  AddressCountry: 'Country',
  AddressCountry_Placeholder: 'Your country',
  AddressDelivery: 'Delivery',
  AddressDelivery2: 'Delivery details 2',
  AddressDelivery2_Placeholder: 'Your delivery details 2',
  AddressDelivery2_Tooltip: 'Enter your delivery details 2',
  AddressDelivery3: 'Delivery details 3',
  AddressDelivery3_Placeholder: 'Your delivery details 3',
  AddressDelivery3_Tooltip: 'Enter your delivery details 3',
  AddressDelivery_Placeholder: 'Your delivery details',
  AddressDelivery_Tooltip: 'Enter your delivery details',
  AddressDistrict: 'District',
  AddressDistrict_Placeholder: 'Your district',
  AddressDistrict_Tooltip: 'Enter your district',
  AddressLocality: 'Locality',
  AddressLocality_Placeholder: 'Your locality',
  AddressLocality_Tooltip: 'Enter your locality',
  AddressProvince: 'Province',
  AddressProvince_Placeholder: 'Your province',
  AddressProvince_Tooltip: 'Enter your province',
  AddressRegion: 'Region',
  AddressRegion_Placeholder: 'Your region',
  AddressRegion_Tooltip: 'Enter your region',
  AddressSearchTooltip: 'Search for your Zip code',
  AddressStreetAddress: 'Street address',
  AddressStreetAddressTooltip: 'Enter your street address',
  AddressStreetAddress_Placeholder: 'Your street address',
  AddressTitle: 'Address details',
  AddressZipcode: 'Zip code',
  AddressZipcode_Placeholder: 'Your Zip code',
  AddressZipcode_Tooltip: 'Enter your Zip code',
  Address_SearchedAddress: 'Searched address',
  Benefits_Header_Title: 'Why join as a Member?',
  Benefits_ShowLess: 'Hide',
  Benefits_ShowMore: 'Read More',
  Benefits_Text1: 'Save on your first order and get free shipping with selected items, every time!',
  Benefits_Text2: "Your purchases, your rewards, it's that simple!",
  Benefits_Text3: 'Recommend your fave products to friends and get rewarded when they shop.',
  Benefits_Title1: '15% off your first order & free shipping',
  Benefits_Title2: '15% cashback on every purchase',
  Benefits_Title3: 'Share the love & get rewarded',
  Custom_text: 'Market specific text about privacy policy and personal data processing for marketing products and services, analytical purposes and profiling. User is informed of their right to request access to data, rectification, deletion, transfer or limitation of processing and to raise objections. Link to more information about how Oriflame processes your personal data.',
  EmailVerification_Header: 'Verify your email',
  EmailVerification_Text: 'To continue with the registration please verify your email. A code was sent to {contactEmail}, you can enter it below.',
  General_Already_Registered: 'Already have an account? {LoginLink}',
  General_header: 'Sign up',
  Legal_Approval_BlockGuaranteeOrdering: "Blocks the consultant's guarantee and SPO sponsors from ordering on their behalf.",
  Legal_Approval_Contact: 'Approval for receiving info emails/SMS',
  Legal_Approval_MarketingConsultant: 'Approval for receiving emails/SMS from beauty consultant',
  Legal_Approval_MarketingExternal: 'Approval for receiving marketing information from external sources',
  Legal_Approval_MarketingOriflame: 'Approval for receiving marketing information from Oriflame',
  Legal_Approval_Newletters: 'Approval for receiving newsletters',
  Legal_Approval_PersonalData: 'Approval for displaying personal data',
  Legal_Approval_Publication: 'Approval Publication',
  Legal_Approval_UplineLeaderBrowse: 'Leader approval for up line Leader to browse leader downline members',
  Legal_Approval_UplineLeaderData: 'Approval UplineLeaderData',
  Legal_Approval_optedOutOfSponsorSelect: 'I do not want to be a sponsor',
  Legal_Approval_orderHistory: 'Order history',
  Legal_Confiramtion2: 'Legal confirmation 2',
  Legal_Confirmation1: 'Legal confirmation 1',
  Legal_PrivacyPolicy: 'I have read and accept the {PrivacyPolicy_Link}.',
  Legal_PrivacyPolicy_Label: 'Privacy Policy',
  Legal_Reseller: 'Reseller',
  Legal_ShowLess: 'Hide',
  Legal_ShowMore: 'More',
  Legal_TermsAndConditions: 'I agree with {TermsAndConditions_Link}.',
  Legal_TermsAndConditions_Label: 'Terms and Conditions',
  Legal_Text: 'By registering as a Member you agree to receive product offers and beauty advice by email and test messages from Oriflame and your Brand Partner.',
  ParentalConsentCheckboxLabel: 'I am under {parentalConsentAge} years old',
  ParentalConsentDescription: 'If you are at least {minAge} years old but not yet {parentalConsentAge}, you can join Oriflame, but we need your parent’s consent.',
  ParentalConsentEmail: 'Email',
  ParentalConsentEmailPlaceholder: '@',
  ParentalConsentEmailTooltip: 'Write your email in the format my@email.com',
  ParentalConsentPendingExplore: 'Explore the website',
  ParentalConsentPendingPageDescription: 'You will become an Oriflame Member as soon your parent gives the consent. Tell your parent to read the SMS we’ve sent and accept it within the next 24 hours. Once they have confirmed, you will get a welcome message from us. If your parent does not accept, we will not be able to register you.',
  ParentalConsentPendingPageTitle: 'Registration pending',
  ParentalConsentPhone: 'Mobile phone',
  ParentalConsentPhoneWithPrefix: 'Mobile Phone',
  ParentalConsentPlaceholderPhone: 'XXXXXXXXX',
  ParentalConsentPlaceholderPhonePrefix: 'XXXXXXXXX',
  ParentalConsentSameEmailValidation: 'The email for parental consent must be different from the contact email.',
  ParentalConsentSamePhoneValidation: 'The phone number for parental consent must be different from the contact phone number.',
  ParentalConsentTitle: 'Younger than {parentalConsentAge}?',
  ParentalConsentTooltipPhone: 'Write your phone in the format +48XXXXXXXXX',
  ParentalConsentTooltipPhoneWithPrefix: 'Write your phone in the format XXXXXXXXX',
  PersonalDetails_Button_Continue: 'Continue',
  PersonalDetails_DateOfBirth: 'Date of birth',
  PersonalDetails_Email: 'Email',
  PersonalDetails_EmailPlaceholder: '@',
  PersonalDetails_Email_Tooltip: 'Write your email in the format my@email.com',
  PersonalDetails_FirstName: 'First name',
  PersonalDetails_Gender: 'Gender',
  PersonalDetails_Gender_Placeholder: 'Choose',
  PersonalDetails_InvitationCodeNotFound: 'Invalid code',
  PersonalDetails_Invite_Code: 'Invite code (optional)',
  PersonalDetails_Invite_Code_Helper_Text: 'Add your friend’s invite code to connect after registration',
  PersonalDetails_LastName: 'Last name',
  PersonalDetails_Passport: 'Passport',
  PersonalDetails_Password: 'Password',
  PersonalDetails_Phone: 'Mobile phone',
  PersonalDetails_PhonePlaceholder: 'XXX XXX XXX',
  PersonalDetails_PhoneWithPrefix: 'Mobile Phone',
  PersonalDetails_PlaceholderPhoneWithPrefix: 'XXXXXXXXX',
  PersonalDetails_Sponsor: 'Sponsor number',
  PersonalDetails_SponsorTitle: 'You were invited by',
  PersonalDetails_Sponsor_Tooltip: 'Enter sponsor number',
  PersonalDetails_TaxCode: 'Tax code',
  PersonalDetails_TaxCode2: 'Tax code2',
  PersonalDetails_TooltipPhone: 'Write your phone in the format +48XXXXXXXXX',
  PersonalDetails_TooltipPhoneWithPrefix: 'Write your phone in the format XXXXXXXXX',
  PersonalDetails_UniqueId: 'Unique ID',
  PersonalDetails_UniqueId_Tooltip: 'Write your unique ID in the format 123456789',
  PersonalDetails_YourSponsor: 'Your sponsor',
  PhoneVerification_Continue: 'Continue',
  PhoneVerification_Header: 'Verify your phone number',
  PhoneVerification_NoCode: 'Didn´t get the code?',
  PhoneVerification_SendAgain: 'Send again',
  PhoneVerification_Text: 'To continue with the registration please verify your phone number. A code was sent to {contactTelephone}, please enter it below.',
  PhoneVerification_Verified: 'Verified',
  PhoneVerification_WrongCode: 'Wrong code,  try one more time or send again.',
  addressResults: '({count} results)',
  addressSearchValidation: 'You have to search for address',
  birthDate_DoesntMatchUniqueId: 'Your birthdate does not match your unique id.',
  birthDate_LegalRequirementsFailed: 'You must be {MinAge} or older',
  birthDate_OutOfRange: 'Date of birth is not valid',
  cannotCreate: 'Cannot create new item',
  cannotDelete: 'Cannot delete',
  cannotGetData: 'Cannot get data from server',
  cannotResend: 'Cannot resend',
  cannotUpdate: 'Cannot update',
  cannotVerify: 'Cannot verify',
  customerServiceLinkLabel: 'customer service',
  customer_NotEligible: 'You are not eligible for customer upgrade.',
  customer_NotUnique: 'You cannot register at the moment. Please contact {customerServiceLink}.',
  document_ExpirationTooSoon: 'Your document will expire too soon.',
  errorOccured: 'An error occured',
  fileTypeIsNotSupported: 'File type is not supported',
  genderLabelMan: 'Man',
  genderLabelOther: 'Other',
  genderLabelWoman: 'Woman',
  hide: 'Hide',
  loginLinkLabel: 'logging in',
  noSuggestions: 'No suggestions',
  passwordRequirementCharactersCount: '{min}+ characters',
  passwordRequirementDigit: 'Numbers',
  passwordRequirementLetter: 'Letter',
  passwordRequirementLowerCaseLetter: 'Lower case letters',
  passwordRequirementSpecialCharacter: 'Special characters',
  passwordRequirementUpperCaseLetter: 'Upper case letters',
  readMore: 'Read more',
  resendInMinute: 'Resend code in 1 minute',
  searchForAnAddress: 'Search for your Zip code',
  successResend: 'Code was resent.',
  termsAndConditions_Mandatory: 'Terms and conditions have to be accepted.',
  validationBirthDateRegex: 'Birth date format should be {correctFormat}, e.g. 24.12.2000',
  validationDateRegex: 'Date format should be {correctFormat}, e.g. 24.12.2000',
  validationEmailIsAlreadyUsed: 'Email is already used. Try {loginLink} instead.',
  validationEmailTerminatedCustomer: 'Cannot change email for terminated customer',
  validationLength: 'Invalid property length',
  validationMandatoryPropertyIsNull: 'This field is required',
  validationMaxLength: 'Maximum {max} characters',
  validationMaxValue: 'The date should not be later than {max}',
  validationMinLength: 'Minimum {min} characters',
  validationMinValue: 'The date should be later than {min}',
  validationRegex: 'This field is not filled in correctly',
  validationRegexBirthDate: 'Please enter your date of birth in the right format DD.MM.YYYY',
  validationRegexEmail: 'Please enter a valid email in the format my@mail.com',
  validationRegexIdentityCardDateExpiration: 'The date should not be later than {max}',
  validationRegexPhone: 'Please enter a valid phone in the format +46XXXXXXXXX',
  validationRegexUniqueID: 'Please enter a valid Unique ID in the format 123456',
  validationRequired: 'This field is required',
  validationUniqueAlias: 'Alias is already used',
  validationUniqueBankAccount: 'Bank account is already used',
  validationUniqueCustomerAttribute: 'Attribute is already used',
  validationUniqueDisplayName: 'Display name is already used',
  validationUniquePhone: 'Phone is already used. Try {loginLink} instead.',
  validationUniqueTaxCode: 'Tax code is already used',
  validationUniqueTaxCode2: 'Tax code 2 is already used',
  validationUniqueUniqueId: 'Unique ID is already used',
  validationValidConfirmationCode: 'Confirmation code is not valid',
  validationValidOldPassword: 'Password does not match to existing password',
  validationValidPhone: 'Phone is not valid',
  validationValidSponsorNumber: 'Sponsor number is not valid',
  validationValidUniqueId: 'Unique ID is not valid',
  validationXmlCharacters: 'Property contains not supported character'
};
const translationsNamespace = exports.translationsNamespace = 'checkout-registration';
//# sourceMappingURL=defaultTranslations.js.map